import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { Slot } from "radix-ui"

import { cn } from "@/custolink-newdesign/lib/utils"

const badgeVariants = cva(
  "cl:inline-flex cl:w-fit cl:shrink-0 cl:items-center cl:justify-center cl:gap-1 cl:overflow-hidden cl:rounded-full cl:border cl:border-transparent cl:px-2 cl:py-0.5 cl:text-xs cl:font-medium cl:whitespace-nowrap cl:transition-[color,box-shadow] cl:focus-visible:border-ring cl:focus-visible:ring-[3px] cl:focus-visible:ring-ring/50 cl:aria-invalid:border-destructive cl:aria-invalid:ring-destructive/20 cl:dark:aria-invalid:ring-destructive/40 cl:[&>svg]:pointer-events-none cl:[&>svg]:size-3",
  {
    variants: {
      variant: {
        default: "cl:bg-primary cl:text-primary-foreground cl:[a&]:hover:bg-primary/90",
        secondary:
          "cl:bg-secondary cl:text-secondary-foreground cl:[a&]:hover:bg-secondary/90",
        destructive:
          "cl:bg-destructive cl:text-white cl:focus-visible:ring-destructive/20 cl:dark:bg-destructive/60 cl:dark:focus-visible:ring-destructive/40 cl:[a&]:hover:bg-destructive/90",
        outline:
          "cl:border-border cl:text-foreground cl:[a&]:hover:bg-accent cl:[a&]:hover:text-accent-foreground",
        ghost: "cl:[a&]:hover:bg-accent cl:[a&]:hover:text-accent-foreground",
        link: "cl:text-primary cl:underline-offset-4 cl:[a&]:hover:underline",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant = "default",
  asChild = false,
  ...props
}: React.ComponentProps<"span"> &
  VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot.Root : "span"

  return (
    <Comp
      data-slot="badge"
      data-variant={variant}
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  )
}

export { Badge, badgeVariants }
